import i18n from "i18next";

const loadJapaneseFont = () => import("@fontsource-variable/noto-sans-jp/wght.css");

i18n.on("languageChanged", (lng) => {
    if (lng.split("-")[0] === "ja") {
        void loadJapaneseFont();
    }
});
